import AGENCY_API from '@/api/agencyContract/index';
import BASE_API from '@/api/dataBase.js';
import { COMPANY_CODE1 } from '@/constants';
export const baseForm = (ctx) => {
  console.log(ctx.baseFormData, '1111');
  return [
    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      placeholder: '请输入外部合同号',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      maxlength: 100,
      // disabled: cs == 'ZT02' || cs == 'ZT03',
      placeholder: '请输入合同名称',
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'serviceContractType' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      placeholder: '请输入客户名称',
      isMultiple: true,
      // disabled: cs == 'ZT02' || cs == 'ZT03',
      currentValue: ctx.baseFormData.customerName,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractBusinessCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      // disabled: cs == 'ZT02' || cs == 'ZT03',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractBusinessDepartment',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
      // disabled: ctx.baseFormData.companyCode == '' || cs == 'ZT02' || cs == 'ZT03',
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      // disabled: cs == 'ZT02' || cs == 'ZT03',
      currentValue: ctx.baseFormData.projectInitiationNo
        ? ctx.baseFormData.projectInitiationNo
        : null,
      checkRowKeys: [
        ctx.baseFormData.projectInitiationNo ? ctx.baseFormData.projectInitiationNo : null,
      ],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.baseFormData.companyCode,
        platformtCompanyName: ctx.baseFormData.companyName,
        applyCompanyNo: ctx.baseFormData.companyCode,
        applyCompanyName: ctx.baseFormData.companyName,
        // applyDepartmentName: ctx.baseFormData.departmentName,
        // applyCompanyNo: ctx.baseFormData.contractBusinessCompanyNo,
        // applyDepartmentNo: ctx.baseFormData.contractBusinessDepartment,
        // platformtCompany: ctx.baseFormData.contractBusinessCompanyNo,
        ///delete
        // recyclingtCompany: ctx.baseFormData.contractBusinessCompanyNo,
        ///delete
        // applyDepartmentName: ctx.baseFormData.contractBusinessDepartmentName,
        // applyCompanyName: ctx.baseFormData.contractBusinessCompanyName,
        // platformtCompanyName: ctx.baseFormData.contractBusinessCompanyName,

        ///delete
        // recyclingtCompanyName: ctx.baseFormData.contractBusinessCompanyName,
        ///delete
      },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: true,
      placeholder: '请输入项目名称',
    },

    {
      prop: 'platformCompanyFileNo',
      name: '平台公司',
      type: 'select',
      options: ctx.platformCompanyFileList,
      placeholder: '请选择平台公司',
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司档案编号',
      type: 'input',
      disabled: true,
    },

    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      // disabled: cs == 'ZT02' || cs == 'ZT03',
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled: cs == 'ZT02' || cs == 'ZT03',
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled: cs == 'ZT02' || cs == 'ZT03',
    },
    {
      prop: 'isNotEndDate',
      name: '至合同履行截止日止',
      labelPosition: 'right',
      falseLable: '0',
      trueLable: '1',
      type: 'checkbox',
    },
    {
      prop: 'contractOperaterName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },

    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司',
    //   type: 'select',
    //   options: ctx.recyclingCompanyFileList,
    //   changeMethod: 'changeMethod',
    //   // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05',
    // },
    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司档案编号',
    //   type: 'input',
    //   disabled: true,
    // },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      disabled: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractCurrency',
      type: 'ajaxSelect',
      name: '币种',
      apiUrl: AGENCY_API.LIST_CURRENCY,
      method: 'get',
      apiData: { isEnabled: 1 },
      valueKey: 'currencyCode',
      moreShowKey: 'currencyCode',
      labelKey: 'currencyName',
      valueType: 'object',
      changeMethod: 'changeMethod',
      // disabled: cs == 'ZT02' || cs == 'ZT03',
    },
    // {
    //   prop: 'isRestrict',
    //   name: '是否定量',
    //   type: 'select',
    //   changeMethod: 'changeMethod',
    //   options: [
    //     {
    //       value: '0',
    //       label: '否',
    //     },
    //     {
    //       value: '1',
    //       label: '是',
    //     },
    //   ],
    //   disabled: cs == 'ZT02' || cs == 'ZT03',
    // },
    {
      prop: 'isDefault',
      name: '是否有违约责任',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      changeMethod: 'changeChecked',
    },
    {
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'liquidatedDamages' },
      type: 'ajaxSelect',
      name: '合同违约金类型',
      prop: 'liquidatedDamagesType',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'liquidatedFixedValue',
      name: '违约金固定值',
      type: 'inputNumber',
      placeholder: '请输入违约金固定值',
      precision: 2,
      append: '元',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'liquidatedInterestRate',
      name: '违约金日利率',
      type: 'inputNumber',
      placeholder: '请输入违约金日利率',
      precision: 6,
      append: '%',
      changeMethod: 'changeMethod',
    },
    {
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'qualityGuaranteeDepositMethod' },
      name: '质保金收取方式',
      prop: 'qualityGuaranteeDepositMethodCode',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'chargeFixedValue',
      name: '收取固定值',
      type: 'inputNumber',
      precision: 2,
      append: '元',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'chargeProportion',
      name: '收取比例',
      append: '%',
      precision: 2,
      type: 'inputNumber',
      changeMethod: 'changeMethod',
    },
    {
      type: 'inputNumber',
      prop: 'qualityGuaranteeDepositOverdue',
      name: '质保金逾期期限',
      precision: 0,
      append: '天',
    },
    {
      prop: 'performanceBondPayMethodCode',
      name: '履约保证金缴纳方式',
      type: 'select',
      options: ctx.dictListMap?.apply_payment_method || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'performanceBond',
      name: '履约保证金',
      type: 'inputNumber',
      placeholder: '请输入履约保证金',
      precision: 2,
      append: '元',
    },
    {
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'input',
      placeholder: '请输入保供条款',
    },
    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      max: 100,
      append: '%',
    },
    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      max: 100,
      append: '%',
    },
    {
      prop: 'businessType',
      name: '业务性质',
      type: 'ajaxSelect',
      clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'purchase_business_type' },
      placeholder: '请选择业务性质',
    },
    {
      prop: 'pricingRule',
      name: '定价模式',
      type: 'ajaxSelect',
      clearable: true,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'pricing_rule' },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'receiptMethod',
      name: '收款方式',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.dictListMap?.apply_payment_method || [],
    },
    {
      prop: 'incomeMethod',
      name: '收益方式',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'incomeMethod' },
      type: 'ajaxSelect',
      placeholder: '请选择收益方式',
    },
    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      changeMethod: 'changeMethod',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
    },
    {
      prop: 'isLongRange',
      name: '是否长期合同',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
    },
    {
      prop: 'performanceBondRecipient',
      name: '保证金收取方',
      type: 'select',
      options: [
        {
          value: '01',
          label: '我方',
        },
        {
          value: '02',
          label: '客方',
        },
      ],
    },
    {
      prop: 'mark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 512,
      // disabled: ctx.contractStatus == 'ZT02' || ctx.contractStatus == 'ZT03',
    },
  ];
};

export const baseFormRule = (ctx) => {
  return {
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
    projectInitiationNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractBusinessCompanyNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractBusinessDepartment: [{ required: true, message: '必填字段', trigger: 'change' }],
    // recyclingCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractCurrency: [{ required: true, message: '必填字段', trigger: 'change' }],
    // isRestrict: [{ required: true, message: '必填字段', trigger: ['blur', 'change'] }],
    contractValidEnd: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    contractValidStart: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    signDate: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
  };
};
